import React from "react";

import AppConstants from "../../constants/AppConstants";
import BlockUtils from "../../utils/BlockUtils";
import Element from "./Element";
import Background from "./Background";
import { gatherProps } from "../../utils/Merge/MergeUtils.mjs";

const {
  BG_PROPERTY_FILL_TYPE,
  BG_PROPERTY_MEDIA_TYPE,
  BLOCK_PROP_PARENT_BLOCK,
  ELEMENT_TYPE_STATES,
} = AppConstants;

class Block extends React.Component {
  _getState = (state, stateId, layout, height) => {
    if (state === false) {
      return null;
    }

    const { layoutWidth, theme, designContext, buttonState, mode } = this.props;
    const background = gatherProps(
      state,
      layout,
      [BG_PROPERTY_FILL_TYPE, BG_PROPERTY_MEDIA_TYPE],
      true
    );

    const elements = state.get("elements");

    const style = {
      width: "100%",
      height: "100%",
      position: "absolute",
    };

    const containersStyle = {
      width: layoutWidth,
      position: "absolute",
      margin: "0 auto",
      height: "100%",
      left: 0,
      right: 0,
    };

    return (
      <div style={style} key={stateId}>
        <Background
          key={`${stateId}BG`}
          background={background}
          layout={layout}
          width={layoutWidth}
          height={height}
          theme={theme}
          designContext={designContext}
        />
        <div style={containersStyle}>
          {elements
            .filter((elem) => !elem.get("pid", false))
            .map((elem, idx) => {
              if (BlockUtils.isVisibleInLayout(elem, layout)) {
                const elementId = BlockUtils.getElementID(stateId, idx);

                return (
                  <Element
                    key={elementId}
                    id={elementId}
                    element={elem}
                    layout={layout}
                    theme={theme}
                    designContext={designContext}
                    buttonState={buttonState}
                    mode={mode}
                  />
                );
              }
            })}
        </div>
      </div>
    );
  };

  _getMissingSiteBlockView = (block, layout) => {
    const height = block.getIn([layout, "h"]);

    const style = {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: "#000000",
      height,
      fontSize: "24px",
      fontFamily: "Arial",
    };

    return (
      <div className="si-block" style={style}>
        <div>SITE CANVAS NOT FOUND</div>
      </div>
    );
  };

  render() {
    const { block, layout, theme, layoutWidth, designContext, buttonState, dataTestId, mode  } = this.props;

    let baseBlock = block;
    const usingSiteBlock = BlockUtils.isUsingSiteBlock(block);

    if (usingSiteBlock) {
      baseBlock = block.get(BLOCK_PROP_PARENT_BLOCK, false);

      if (baseBlock === false) {
        return this._getMissingSiteBlockView(block, layout);
      }
    }

    const blockId = block.get("id");
    const isBlogState =
      (block.getIn(["wp", "stackViews"], false) === 1 && block.getIn(["wp", "type"]) === "post") ||
      block.getIn(["wp", "type"]) === "posts_lookup";
    const height = baseBlock.getIn([layout, "h"]);
    const background = gatherProps(
      baseBlock,
      layout,
      [BG_PROPERTY_FILL_TYPE, BG_PROPERTY_MEDIA_TYPE],
      true
    );
    const selected = block.get("selected");
    const selectedState = selected != null ? selected.get("blockState") : null;

    const style = {
      position: "relative",
      width: "100%",
      height,
      minHeight: height,
      minWidth: layoutWidth,
    };

    const containerStyle = {
      width: layoutWidth,
      position: "absolute",
      margin: "0 auto",
      height: "100%",
      left: 0,
      right: 0,
    };

    const zIndex = block.get("z", false);
    if (zIndex) {
      style.zIndex = zIndex;
    }

    let activeState = false;
    let activeStateId = null;

    if (selected) {
      if (selectedState) {
        const statePath = BlockUtils.getElementPath(selectedState);
        activeState = block.getIn(statePath, false);
        activeStateId = selectedState;
      }
    } else {
      activeState = baseBlock.getIn(["states", 0], false);
      activeStateId = usingSiteBlock
        ? BlockUtils.getSiteBlockStateID(blockId, 0)
        : BlockUtils.getStateID(blockId, 0);
    }

    let renderGroup = null;

    const bgElements = [];
    const fgElements = [];

    renderGroup = bgElements;

    const elements = baseBlock.get("elements");
    const states = block.get("states", false);
    elements
      .filter((elem) => !elem.get("pid", false))
      .forEach((elem, idx) => {
        const type = elem.get("type");

        if (BlockUtils.isVisibleInLayout(elem, layout)) {
          const elementId = BlockUtils.getElementID(blockId, idx);

          renderGroup.push(
            <Element
              key={elementId}
              id={elementId}
              element={elem}
              layout={layout}
              theme={theme}
              designContext={designContext}
              buttonState={buttonState}
              mode={mode}
            />
          );
        }

        if (activeState && type === ELEMENT_TYPE_STATES) {
          renderGroup = fgElements;
        }
      });

    return (
      <div
        className="si-block"
        data-testid={dataTestId}
        style={style}
        data-selected={!!selected || undefined}
      >
        <Background
          background={background}
          layout={layout}
          width={layoutWidth}
          height={height}
          theme={theme}
          designContext={designContext}
        />
        <div style={containerStyle}>{bgElements}</div>

        {isBlogState && states
          ? states.map((state, idx) => {
              const stateId = BlockUtils.getStateID(blockId, idx);
              return this._getState(state, stateId, layout, height);
            })
          : this._getState(activeState, activeStateId, layout, height)}
        <div style={containerStyle}>{fgElements}</div>
      </div>
    );
  }
}

export default Block;
